"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Pressable = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Pressable"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.viewProps]);
function selectContainerStyles(_ref) {
  let {
    backgroundColor,
    borderColor,
    borderWidth,
    borderStyle = 'solid',
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    justifyContent,
    verticalAlign,
    iconPosition,
    borderTopRightRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderBottomLeftRadius
  } = _ref;
  return {
    boxSizing: 'border-box',
    backgroundColor,
    borderColor,
    borderWidth,
    borderStyle,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    justifyContent,
    borderTopRightRadius,
    borderBottomRightRadius,
    borderTopLeftRadius,
    borderBottomLeftRadius,
    ...(0, _ThemeProvider.verticalAlignRow)(verticalAlign, iconPosition === 'right'),
    // Updated default alignment due to the change in Pressable's behavior from div to button on web.
    textAlign: _Platform.default.OS === 'web' ? 'inherit' : undefined
  };
}

// TODO: use stack / spacer when available
function selectIconContainerStyles(_ref2) {
  let {
    iconGap,
    iconPaddingTop,
    iconPosition
  } = _ref2;
  const paddingSide = iconPosition === 'right' ? 'paddingLeft' : 'paddingRight';
  return {
    [paddingSide]: iconGap,
    paddingTop: iconPaddingTop
  };
}
function selectTextContainerStyles(_ref3) {
  let {
    textLine
  } = _ref3;
  return {
    textDecorationLine: textLine,
    flex: 1
  };
}
function selectIconTokens(tokens) {
  return {
    color: tokens.iconColor,
    size: tokens.iconSize
  };
}
const ExpandCollapseControl = /*#__PURE__*/_react.default.forwardRef((_ref4, ref) => {
  let {
    onPress,
    isExpanded,
    children,
    tokens,
    accessibilityRole = 'button',
    variant,
    ...rest
  } = _ref4;
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('ExpandCollapseControl', tokens, variant);
  const selectedProps = selectProps({
    accessibilityRole,
    ...rest,
    accessibilityState: {
      ...(rest.accessibilityState || {}),
      expanded: isExpanded
    }
  });
  const getControlState = _ref5 => {
    let {
      pressed,
      hovered,
      focused
    } = _ref5;
    return {
      pressed,
      hover: hovered,
      focus: focused,
      expanded: isExpanded
    };
  };
  const getControlTokens = pressableState => getTokens(getControlState(pressableState));
  const getPressableStyle = pressableState => ({
    ...selectContainerStyles(getControlTokens(pressableState)),
    ...(_Platform.default.OS === 'web' ? {
      outline: 'none'
    } : {})
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pressable.default, {
    ref: ref,
    ...selectedProps,
    onPress: onPress,
    style: getPressableStyle,
    children: pressableState => {
      const {
        icon: IconComponent,
        ...themeTokens
      } = getControlTokens(pressableState);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [IconComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
          style: [selectIconContainerStyles(themeTokens), staticStyles.bubblePointerEvents],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
            ...selectIconTokens(themeTokens)
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
          style: [selectTextContainerStyles(themeTokens), staticStyles.bubblePointerEvents],
          children: typeof children === 'function' ? children(getControlState(pressableState)) : children
        })]
      });
    }
  });
});
ExpandCollapseControl.displayName = 'ExpandCollapseControl';
const staticStyles = _StyleSheet.default.create({
  bubblePointerEvents: {
    pointerEvents: 'none'
  }
});
ExpandCollapseControl.propTypes = {
  ...selectedSystemPropTypes,
  tokens: (0, _utils.getTokensPropType)('ExpandCollapseControl'),
  variant: _utils.variantProp.propType,
  /**
   * ExpandCollapseControl's children are the content within the button that opens or closes this panel. May
   * accept a render function that recieves the control state: { pressed, hover, focus, expanded }
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * Whether the linked ExpandCollapsePanel is opened or closed. Allows themes to set `expanded` styles.
   */
  isExpanded: _propTypes.default.bool,
  /**
   * Function called when the ExpandCollapse is pressed.
   */
  onPress: _propTypes.default.func.isRequired
};
var _default = exports.default = ExpandCollapseControl;